import React from "react";
export const color = {
  RED: "#FF4961",
  GREEN: "#0ABB87",
  ORANGE: "#FFB82F",
  PURPLE: "#5867DD",
  BLUE: "#1E9FF2",
};

const colorCheme = {
  INACTIVE: color.RED,
  LOC:color.BLUE,
  FAST_LOAN:color.ORANGE,
  ACTIVE: color.GREEN,
  CANCELLED: color.RED,
  Cancelled: color.RED,
  REVERSED: color.RED,
  NOT_PAID: color.RED,
  HOLD:color.RED,
  hold:color.ORANGE,
  FAILURE: color.RED,
  FAILED: color.RED,
  FAILED_INTERRUPTED: color.RED,
  No: color.RED,
  NO: color.RED,
  REFUNDED: color.RED,
  DISCARDED:color.RED,
  REJECT: color.RED,
  BOUNCE: color.RED,
  PAID: color.GREEN,
  captured: color.GREEN,
  CREATED: color.GREEN,
  SUCCESS: color.GREEN,
  success: color.GREEN,
  Yes: color.GREEN,
  YES: color.GREEN,
  Edit: color.GREEN,
  CHEQUE_PROCESSED: color.GREEN,
  RESOLVED: color.GREEN,
  Approved: color.GREEN,
  APPROVED: color.GREEN,
  Verified: color.GREEN,
  COMPLETED: color.GREEN,
  NACH_REQUESTED: color.ORANGE,
  "Not Verified": color.ORANGE,
  "Not Checked": color.ORANGE,
  "IN-PROGRESS": color.ORANGE,
  UPLOADED: color.ORANGE,
  Ongoing: color.ORANGE,
  PROCESSING: color.ORANGE,
  CLOSED: color.RED,
  ONGOING: color.PURPLE,
  DELIQUENT: color.RED,
  PARTIAL_PAID: color.ORANGE,
  INITIATE: color.PURPLE,
  initiate: color.PURPLE,
  ASSIGNED_TO_FINANCIER: color.ORANGE,
  COND_APPROVED: color.ORANGE,
  FINAL_APPROVED: color.GREEN,
  APPROVE:color.GREEN,
  CUST_ABORT: color.PURPLE,
  DENIED_1: color.RED,
  DENIED_2: color.RED,
  NOT_SEEN: color.RED,
  TIMED_OUT: color.RED,
  REWORK:color.RED,
  TIMEDOUT: color.RED,
  PENDING:color.ORANGE,
  CREDIT:color.GREEN,
  "REVERSAL TIMEDOUT":color.ORANGE,
  SUBMITTED_TO_BANK:color.GREEN,
  REJECTED:color.RED,
  RETRY:color.BLUE,
  AUTHORISED:color.PURPLE,
  READY_TO_SUBMIT:color.PURPLE,
  NACH_PROCESSED:color.GREEN,
  ARCHIVED:'grey',
  DISBURSAL_STARTED:color.ORANGE,
  FORMED:color.PURPLE,
  READY_FOR_DISBURSAL:color.BLUE,
  DISBURSED:color.GREEN,
  KYC_COMPLETED:color.GREEN,
  BANK_ADDED:color.BLUE,
  KYC_INCOMPLETE:color.RED,
  TNC_ACCEPTED:color.PURPLE,
  JOINED:color.GREEN,
  EXITED:color.RED,
  ADDRESS:color.PURPLE,
  NAME:color.GREEN,
  PAN:color.GREEN,
  GENDER:color.BLUE,
  MOBILE:color.ORANGE,
  DOB:color.GREEN,
  normal:color.GREEN,
  bullet:color.BLUE,
  flexible:color.ORANGE,
  SUSPENDED:color.ORANGE,
  CONDITIONAL:color.BLUE,
  Active:color.GREEN,
  Inactive:color.RED,
  TERMINATE:color.BLUE,
  created:color.BLUE,
  failed:color.RED,
  pending:color.PURPLE,
  authorized:color.GREEN,
  soft_failed:color.ORANGE,
  inactive:color.RED,
  "IN PROGRESS": color.BLUE
};

export const BootstrapBadge = ({
  text,
  color,
  backgroundColor = false,
  fontSize,
    className = "",
}) => {
  return (
    <span
      className={`common_bagde_size ${className}`}
      style={{
        color: colorCheme[text]?color||'#fff':color ||'#000',
        backgroundColor: backgroundColor || colorCheme[text],
        padding: "4px 7px",
        fontSize: fontSize || "0.6875rem",
        borderRadius: "3px",
        fontFamily: "poppins-medium",
        margin:"1px"
      }}
    >
      {text}
    </span> 
  );
};
